<template>
    <template v-for="menuItem in models" v-bind:key="menuItem">
        <template v-if="!menuItem.disabled">
            <template v-if="menuItem.childMenuItem.length === 0">
                <div class="scv-dropdown-menu-button">

                    <a class="dropdown-item" href="#" @click="onClickMenuItem(menuItem.menuItemID)">
                        {{ menuItem.description }}
                    </a>
                </div>
            </template>
            <template v-else>
                <div class="dropright scv-dropdown-sub">
                    <div class="scv-dropdown-menu-button">
                        <a class="dropdown-item" href="#" role="button" data-bs-toggle="dropdown" @click="onClickMenuItem(menuItem.menuItemID)">
                            {{ menuItem.description }}
                            <div class="icon-font-silver-gray scv-dropdown-icon-right ms-auto">
                                <i class="icon-arrow1right"></i>
                            </div>
                        </a>
                        <!--サブメニュー1階層目:2階層目以降は対応しておりません。-->
                        <ul class="dropdown-menu scv-dropdown-menu scv-dropdown-sub-menu">
                            <template v-for="childMenuItem in  menuItem.childMenuItem" v-bind:key="childMenuItem">
                                <li class="scv-dropdown-menu-button">
                                    <a class="dropdown-item" href="#" @click="onClickMenuItem(childMenuItem.menuItemID)">
                                        {{childMenuItem.description}}
                                    </a>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
            </template>
        </template>
        <template v-else>
            <div class="scv-dropdown-menu-button">
                <template v-if="menuItem.childMenuItem.length === 0">
                    <a class="dropdown-item scv-dropdown-item-disabled" disabled>
                        {{ menuItem.description }}
                    </a>
                </template>
                <template v-else>
                    <a class="dropdown-item scv-dropdown-item-disabled" disabled>
                        {{ menuItem.description }}
                        <div class="icon-font-silver-gray scv-dropdown-icon-right ms-auto">
                            <i class="icon-arrow1right"></i>
                        </div>
                    </a>
                </template>
            </div>
        </template>
    </template>
</template>

<script lang="ts">
    import { Options, Vue } from "vue-class-component";

    @Options({
        props: {
            models: { type: Array, Default: {} }, // メニューリスト : Array<MenuItemBase>
        },
        emits: [
            /*
             * リストクリック時
             * @param[in]   menuItemID メニューリストのID
             */
            'onClickMenuItem',
        ]
    })

    /*
    *  【OperationMenuの説明】
    *  メニューリスト作成を行います
    *  childMenuItem（サブメニュは1階層目までしか対応しておりません。）
    *
    *  【OperationMenuの使い方（基本）】
    *  メニューリストの定義
    *  private readonly menuItemList: Array<MenuItemBase> =
    *       [
    *          { menuItemID: 0 , childMenuItem: [], description: "Menue1", disabled: false//メニュー押下を無効にするかどうか },
    *          { menuItemID: 1 , childMenuItem: [], description: "Menue2", disabled: true//メニュー押下を無効にするかどうか },
    *           ...
    *       ];
    *
    *  メニュー押下時の処理を実装
    *  // 
    *  // メニュー押下時の処理
    *  //
    *  private onClickMenuItem(menuItemID: Number): void {
    *      if (menuItemID == 0) {
    *          ...
    *   }
    *      else {
    *          ...
    *      }
    *      return ;
    *  }
    *
    * HTMLで定義
    *      <OperationMenu :models="menuItemList" @onClickMenuItem="onClickMenuItem" />
    */
    export default class OperationMenu extends Vue {
        public onClickMenuItem(menuItemID: number): void {
            this.$emit("onClickMenuItem", menuItemID);
        }
    }

</script>
